import { labelProfilo } from "_constants";
import { HeaderMainContent } from "components/shared";
import { Divider } from "primereact/divider";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAppSelector } from "store/store";
import { SaveNewAnagraficaToast } from "./components";
import { ProfileContainer } from "./components/ProfileContainer";

export const ProfilePage = () => {
  const profile = useAppSelector((state) => state.profiloSlice);
  const [visible, setVisible] = useState(false);

  const { control, formState, setValue, handleSubmit, watch } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      lastName: "",
      email: "",
    },
    shouldFocusError: false,
  });
  const allWatchedFormValues = watch();

  useEffect(() => {
    setValue("name", profile.firstName);
    setValue("lastName", profile.lastName);
    setValue("email", profile.email);
  }, [profile, setValue]);

  useEffect(() => {
    if (
      allWatchedFormValues.name !== profile.firstName ||
      allWatchedFormValues.lastName !== profile.lastName
    ) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [allWatchedFormValues.name, allWatchedFormValues.lastName, profile]);

  return (
    <>
      <HeaderMainContent label={labelProfilo} />
      <Divider className="margin-top-0 margin-bottom-0" />
      <div className="profile-container">
        <ProfileContainer control={control} handleSubmit={handleSubmit} />
        {visible && <SaveNewAnagraficaToast formState={formState} />}
      </div>
    </>
  );
};
